// removed by extract-text-webpack-plugin
module.exports = {"title-modal":"app-components-ConfirmActionModal-__ConfirmActionModal___398dX","dialog":"app-components-ConfirmActionModal-__ConfirmActionModal___16QXf"};


//////////////////
// WEBPACK FOOTER
// ./app/components/ConfirmActionModal/ConfirmActionModal.css
// module id = 2161
// module chunks = 0